import { render, staticRenderFns } from "./FrecuenciasMantenimiento.vue?vue&type=template&id=04d2332c&scoped=true"
import script from "./FrecuenciasMantenimiento.vue?vue&type=script&lang=js"
export * from "./FrecuenciasMantenimiento.vue?vue&type=script&lang=js"
import style0 from "./FrecuenciasMantenimiento.vue?vue&type=style&index=0&id=04d2332c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d2332c",
  null
  
)

export default component.exports